import { Dropdown } from "antd"
import cls from "classname"
import { useLocation, useNavigate } from "react-router"

import Icon from "../../../../Icon"

import "./NavGroup.less"

const NavGroup = ({ icon, groupTitle, items }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const selectedKeys = items
    .filter((item) => location.pathname.includes(item.url))
    .sort((a, b) => b.url.length - a.url.length)
    .slice(0, 1)
    .map((item) => item.url)

  const active = selectedKeys.length > 0

  return (
    <Dropdown
      menu={{
        items: items.map((item) => ({
          key: item.url,
          label: item.text,
          disabled: item.disabled
        })),
        selectable: true,
        selectedKeys,
        onClick: ({ key }) => {
          navigate(key)
        },
        className: "nav-group-dropdown-menu"
      }}
      getPopupContainer={() => document.getElementById("global-wrap")}
      trigger={["click"]}
      placement="bottom"
    >
      <div
        className={cls("sidebar-link", "nav-group-dropdown-trigger", {
          active
        })}
      >
        <div className="sidebar-link_icon-wrap">{icon}</div>
        <span className="sidebar-link_text">{groupTitle}</span>
        <Icon type="chevron_down_small" />
      </div>
    </Dropdown>
  )
}

export default NavGroup
